module.exports = __webpack_public_path__ + "static/media/combat(21).080789aa.PNG";